import SvgSprite from '@Web/Src/Components/SvgSprite';
import Button from '@Web/Src/Components/Button';
import { router } from '@inertiajs/react';

const handleSubmit = (routeName) => {
    router.visit(route(routeName));
};

const PricingCard = ({ plan, yearlyOn }) => {
    const {
        theme,
        name,
        monthly,
        yearly,
        button,
        users,
        campaigns,
        features,
        extraFeatures,
    } = plan;

    return (
        <div
            className={`${
                theme === 'dark' ? 'bg-dark text-light' : 'text-dark bg-white'
            } main-shadow h-full w-full rounded-3xl p-6 text-base`}
        >
            <p>{name}</p>
            <p className='text-5xl font-bold'>
                {yearlyOn ? yearly.price : monthly.price}
                <span className='!text-base'>{__('/ month')}</span>
            </p>
            <p className='text-tertiary h-4'>{yearlyOn ? yearly.label : monthly.label}</p>
            <Button
                className={`${theme === 'dark' ? '!bg-yellow text-dark !border-yellow' : '!text-blue hover:!text-light'} mt-6 w-full`}
                containerType='second'
                name={button.text}
                onClick={() => handleSubmit(button.link)}
            />
            <p className='mt-6'>{users} users</p>
            <p>{campaigns}</p>
            <div className='border-t-grey mt-4 border-t border-solid pt-2'>
                <p className='mt-2 font-bold'>{features}</p>
                {extraFeatures.map((feature, index) => (
                    <div className={'mt-2 flex items-center gap-2'} key={index}>
                        <SvgSprite
                            className={`${theme === 'dark' ? 'text-light' : 'text-blue'} !size-6 flex-shrink-0`}
                            collectionName='pricing-icons-sprite'
                            iconId='check'
                        />
                        <p>
                            {feature.includes(':ownDataPrice')
                                ? feature.replace(
                                      ':ownDataPrice',
                                      yearlyOn ? '(+$400)' : '(+$500)'
                                  )
                                : feature}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PricingCard;
